import { render, staticRenderFns } from "./interface.vue?vue&type=template&id=ecf134c2&"
import script from "./interface.vue?vue&type=script&lang=js&"
export * from "./interface.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports